import { apiDaInscricao } from './axios';

export const obterTokenAcessoAdministrativo = async (identificador: string) => {
  return await apiDaInscricao().get(`/usuario/obterTokenAcessoAdministrativo?identificadorDoUsuario=${identificador}`);
};